import { create, delete$, retrieve, update } from "framework/http/endpoint";
import { fromApiTransportDate, fromApiTransportDateTimeOffset, intoApiTransportDate, intoApiTransportDateTimeOffset } from "framework/http/transport";
import { createCollectionResponseFactory, createEntityResponseFactory } from "framework/http/rest/jsonResponse";
import { create as createRequest, createEntityRequest } from "framework/http/rest/jsonRequest";
import { UrlPathOfApiLocation } from "common/paths";
var ApiUriPrefix = "".concat(UrlPathOfApiLocation, "/api/1/");
var EventsApiUri = ApiUriPrefix + "events";
//---------------------------------
// Events
//---------------------------------
function apiGetEvent(eventId) {
    var uri = "".concat(EventsApiUri, "/").concat(eventId);
    return retrieve(uri, null, createEntityResponseFactory(fromTransportEvent));
}
function apiGetEvents(filter) {
    if (filter === void 0) { filter = null; }
    var filterQry = filter != null ? '?filter=' + encodeURIComponent(filter) : '';
    var uri = "".concat(EventsApiUri).concat(filterQry);
    return retrieve(uri, null, createCollectionResponseFactory(fromTransportEvent));
}
function apiGetPlanningEvents(filter) {
    if (filter === void 0) { filter = null; }
    var filterQry = filter != null ? '?filter=' + encodeURIComponent(filter) : '';
    var uri = "".concat(EventsApiUri, "/planning").concat(filterQry);
    return retrieve(uri, null, createCollectionResponseFactory(fromTransportEvent));
}
function apiCreateEvent(event) {
    var uri = "".concat(EventsApiUri);
    var transport = intoTransportEvent(event);
    var request = createEntityRequest(transport);
    return create(uri, request, createEntityResponseFactory(fromTransportEvent));
}
function apiUpdateEvent(event) {
    var uri = "".concat(EventsApiUri, "/").concat(event.id);
    var transport = intoTransportEvent(event);
    var request = createEntityRequest(transport);
    return update(uri, request, createEntityResponseFactory(fromTransportEvent));
}
function fromTransportEventCompetition(entity) {
    entity.date = fromApiTransportDate(entity.date);
    entity.createdDate = fromApiTransportDateTimeOffset(entity.createdDate);
    entity.updateDate = fromApiTransportDateTimeOffset(entity.updateDate);
    entity.cancelDate = fromApiTransportDateTimeOffset(entity.updateDate);
    entity.publishingDate = fromApiTransportDateTimeOffset(entity.publishingDate);
    entity.registrationDeadline = fromApiTransportDateTimeOffset(entity.registrationDeadline);
    entity.excuseDeadline = fromApiTransportDateTimeOffset(entity.excuseDeadline);
    entity.juryMeeting = fromApiTransportDateTimeOffset(entity.juryMeeting);
    entity.registrationTimesDeadline = fromApiTransportDateTimeOffset(entity.registrationTimesDeadline);
    entity.competitionCancelDeadline = fromApiTransportDateTimeOffset(entity.competitionCancelDeadline);
    return entity;
}
function intoTransportEventCompetition(entity) {
    var result = JSON.parse(JSON.stringify(entity));
    result.date = intoApiTransportDate(entity.date);
    result.createdDate = intoApiTransportDateTimeOffset(entity.createdDate);
    result.updateDate = intoApiTransportDateTimeOffset(entity.updateDate);
    result.cancelDate = intoApiTransportDateTimeOffset(entity.cancelDate);
    result.publishingDate = intoApiTransportDateTimeOffset(entity.publishingDate);
    result.registrationDeadline = intoApiTransportDateTimeOffset(entity.registrationDeadline);
    result.juryMeeting = intoApiTransportDateTimeOffset(entity.juryMeeting);
    return result;
}
function fromTransportEvent(entity) {
    entity.dateFrom = fromApiTransportDate(entity.dateFrom);
    entity.dateTo = fromApiTransportDate(entity.dateTo);
    entity.eventCompetitions.forEach(function (x) {
        x = fromTransportEventCompetition(x);
    });
    return entity;
}
function intoTransportEvent(entity) {
    var result = JSON.parse(JSON.stringify(entity));
    result.dateFrom = intoApiTransportDate(entity.dateFrom);
    result.dateTo = intoApiTransportDate(entity.dateTo);
    entity.eventCompetitions.forEach(function (x, i) {
        result.eventCompetitions[i] = intoTransportEventCompetition(x);
    });
    return result;
}
//---------------------------------
// Competitions
//---------------------------------
function apiGetCompetitions(eventId, filter, order) {
    if (filter === void 0) { filter = null; }
    if (order === void 0) { order = null; }
    var uriRoot = "".concat(EventsApiUri, "/").concat(eventId, "/competitions");
    var queryParams = [];
    if (filter != null) {
        queryParams.push('filter=' + encodeURIComponent(filter));
    }
    if (order != null) {
        queryParams.push('order=' + encodeURIComponent(order));
    }
    var uri = queryParams.length > 0 ? uriRoot + "?" + queryParams.join("&") : uriRoot;
    return retrieve(uri, null, createEntityResponseFactory(fromTransportCompetition));
}
function apiGetCompetition(eventId, competitionId) {
    var uri = "".concat(EventsApiUri, "/").concat(eventId, "/competitions/").concat(competitionId);
    return retrieve(uri, null, createEntityResponseFactory(fromTransportCompetition));
}
function apiCreateCompetition(eventId, comp) {
    var uri = "".concat(EventsApiUri, "/").concat(eventId, "/competitions");
    var transport = intoTransportCompetition(comp);
    var request = createEntityRequest(transport);
    return create(uri, request, createEntityResponseFactory(fromTransportCompetition));
}
function apiUpdateCompetition(eventId, comp) {
    var uri = "".concat(EventsApiUri, "/").concat(eventId, "/competitions/").concat(comp.id);
    var transport = intoTransportCompetition(comp);
    var request = createEntityRequest(transport);
    return update(uri, request, createEntityResponseFactory(fromTransportCompetition));
}
function apiDeleteCompetition(eventId, competitionId) {
    var uri = "".concat(EventsApiUri, "/").concat(eventId, "/competitions/").concat(competitionId);
    return delete$(uri);
}
function fromTransportCompetition(entity) {
    return entity;
}
function intoTransportCompetition(entity) {
    var result = JSON.parse(JSON.stringify(entity));
    return result;
}
//---------------------------------
// Officials
//---------------------------------
function apiGetEventOfficials(eventId, eventCompetitionId) {
    if (eventCompetitionId === void 0) { eventCompetitionId = null; }
    var uriRoot = "".concat(EventsApiUri, "/").concat(eventId, "/officials");
    var uri = eventCompetitionId ? uriRoot + "?eventCompetitionId=".concat(eventCompetitionId) : uriRoot;
    return retrieve(uri, null, createEntityResponseFactory(fromTransportEventOfficial));
}
function apiGetEventOfficial(eventId, officialId) {
    var uri = "".concat(EventsApiUri, "/").concat(eventId, "/officials/").concat(officialId);
    return retrieve(uri, null, createEntityResponseFactory(fromTransportEventOfficial));
}
function apiCreateEventOfficial(eventId, official) {
    var uri = "".concat(EventsApiUri, "/").concat(eventId, "/officials");
    var transport = intoTransportEventOfficial(official);
    var request = createEntityRequest(transport);
    return create(uri, request, createEntityResponseFactory(fromTransportEventOfficial));
}
function apiUpdateEventOfficial(eventId, official) {
    var uri = "".concat(EventsApiUri, "/").concat(eventId, "/officials/").concat(official.id);
    var transport = intoTransportEventOfficial(official);
    var request = createEntityRequest(transport);
    return update(uri, request, createEntityResponseFactory(fromTransportEventOfficial));
}
function apiDeleteEventOfficial(eventId, officialId) {
    var uri = "".concat(EventsApiUri, "/").concat(eventId, "/officials/").concat(officialId);
    return delete$(uri);
}
function fromTransportEventOfficial(entity) {
    return entity;
}
function intoTransportEventOfficial(entity) {
    var result = JSON.parse(JSON.stringify(entity));
    //  result.role = Number(entity.role); // hack, entita by měla zacovat svuj typ
    return result;
}
//---------------------------------
// Competitors
//---------------------------------
function apiGetCompetitors(eventId, eventCompetitionId) {
    if (eventCompetitionId === void 0) { eventCompetitionId = null; }
    var uriRoot = "".concat(EventsApiUri, "/").concat(eventId, "/competitors");
    var uri = eventCompetitionId ? uriRoot + "?eventCompetitionId=".concat(eventCompetitionId) : uriRoot;
    return retrieve(uri, null, createCollectionResponseFactory(fromTransportCompetitor));
}
function apiGetCompetitor(eventId, competitorId) {
    var uri = "".concat(EventsApiUri, "/").concat(eventId, "/competitors/").concat(competitorId);
    return retrieve(uri, null, createEntityResponseFactory(fromTransportCompetitor));
}
function apiCreateCompetitor(eventId, competitor) {
    var uri = "".concat(EventsApiUri, "/").concat(eventId, "/competitors");
    var transport = intoTransportCompetitor(competitor);
    var request = createEntityRequest(transport);
    return create(uri, request, createEntityResponseFactory(fromTransportCompetitor));
}
function apiUpdateCompetitor(eventId, competitor) {
    var uri = "".concat(EventsApiUri, "/").concat(eventId, "/competitors/").concat(competitor.competitorId);
    var transport = intoTransportCompetitor(competitor);
    var request = createEntityRequest(transport);
    return create(uri, request, createEntityResponseFactory(fromTransportCompetitor));
}
function apiDeleteCompetitor(eventId, competitionId, competitorId) {
    var uri = "".concat(EventsApiUri, "/").concat(eventId, "/competitors/").concat(competitorId, "?competitionId=").concat(competitionId);
    return delete$(uri);
}
function fromTransportCompetitor(entity) {
    var result = JSON.parse(JSON.stringify(entity));
    result.registrationDate = fromApiTransportDateTimeOffset(entity.registrationDate);
    result.deregisteredDate = fromApiTransportDateTimeOffset(entity.deregisteredDate);
    return result;
}
function intoTransportCompetitor(entity) {
    var result = JSON.parse(JSON.stringify(entity));
    return result;
}
//---------------------------------
// Availablecompetitions
//---------------------------------
function apiGetAvailableCompetitionsForCompetitor(competitorInfo, eventId, eventCompetitionId) {
    if (eventCompetitionId === void 0) { eventCompetitionId = null; }
    var uriRoot = "".concat(EventsApiUri, "/").concat(eventId, "/available_competitions");
    var uri = eventCompetitionId ? uriRoot + "?eventCompetitionId=".concat(eventCompetitionId) : uriRoot;
    var transport = intoTransportCompetitorInfo(competitorInfo);
    var request = createRequest(transport);
    return create(uri, request, createEntityResponseFactory(fromTransportCompetitionRegistration));
}
function fromTransportCompetitionRegistration(entity) {
    return entity;
}
function intoTransportCompetitorInfo(entity) {
    var result = JSON.parse(JSON.stringify(entity));
    //result.birthDate1 = intoApiTransportDate(entity.birthDate1);
    //result.birthDate2 = intoApiTransportDate(entity.birthDate2);
    return result;
}
export { apiGetEvents, apiGetPlanningEvents, apiGetEvent, apiCreateEvent, apiUpdateEvent, apiGetCompetitions, apiGetCompetition, apiCreateCompetition, apiUpdateCompetition, apiDeleteCompetition, apiGetEventOfficials, apiGetEventOfficial, apiCreateEventOfficial, apiUpdateEventOfficial, apiDeleteEventOfficial, apiGetCompetitors, apiGetCompetitor, apiCreateCompetitor, apiUpdateCompetitor, apiDeleteCompetitor, apiGetAvailableCompetitionsForCompetitor, };
